function componentsRepositionCustomerPage() {
    hideOrderStatus();  
}

function hideOrderStatus() {
  var orderDate;
  var orderDateParagraph = $(".in-objednavky.customer-page #content .content-inner div > p:first-child");
  
  switch(lang) {
    case 'sk':
      orderDate = 'Dátum objednávky:';
      break;
    case 'hu':
      orderDate = 'Megrendelés dátuma:';
      orderDateParagraph = $(".in-rendelesek.customer-page #content .content-inner div > p:first-child");
      break;
    case 'cs':
      orderDate = 'Datum objednávky:';
      break;
    case 'ro':
      orderDate = 'Data comenzii:';
      orderDateParagraph = $(".in-comenzile-mele.customer-page #content .content-inner div > p:first-child");
      break;
    case 'bg':
      orderDate = 'Dátum objednávky:';
      break;
    case 'hr':
      orderDate = 'Datum narudžbe:';
      break;
    case 'si':
      orderDate = 'Datum naročila:';
      break;
    case 'ua':
      orderDate = 'Dátum objednávky:';
      break;
    default:
    return;
  }

  if (orderDateParagraph.length > 0) {
    var contents = orderDateParagraph.contents();

    contents.each(function() {
      if (this.nodeType === 3 && $(this).text().trim().startsWith(orderDate)) {
        var wrappOrderDate = $('<span class="show-order-date">' + $(this).text().trim() + '</span>');
        $(this).replaceWith(wrappOrderDate);
        wrappOrderDate.parent().addClass('hide-element-order-status');

        return false;
        }
    });
  }
}